import { rootApi } from '../rootApi';
import { useGetUserListQuery } from './administratorPage';

const assertSuccessfulResponse = (response, fallbackMessage = 'API_ERROR') => {
    if (response?.isSuccessful) {
        return response.data;
    }

    throw new Error(response?.errorMessage || fallbackMessage);
};

export const managerRoleClaimApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getManagerRoleClaimList: builder.query({
            query: () => ({
                url: 'v1/ManagerRoleClaim',
                method: 'GET'
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && Array.isArray(response.data)) {
                    return response.data;
                }
                return [];
            },
            providesTags: ['SuperAdminDefinition']
        }),

        addManagerRoleClaim: builder.mutation({
            query: (userId) => ({
                url: `v1/ManagerRoleClaim/${userId}`,
                method: 'POST'
            }),
            transformResponse: (response) => assertSuccessfulResponse(response),
            invalidatesTags: ['SuperAdminDefinition']
        }),

        removeManagerRoleClaim: builder.mutation({
            query: (userId) => ({
                url: `v1/ManagerRoleClaim/${userId}`,
                method: 'DELETE'
            }),
            transformResponse: (response) => assertSuccessfulResponse(response),
            invalidatesTags: ['SuperAdminDefinition']
        })
    })
});

export const {
    useGetManagerRoleClaimListQuery,
    useAddManagerRoleClaimMutation,
    useRemoveManagerRoleClaimMutation
} = managerRoleClaimApi;

export const useGetSuperAdminUserListQuery = useGetUserListQuery;
